// constants/cardStyles.js - Card Style Constants for Greeting Cards

export const CARD_STYLES = [
  {
    id: 'default',
    name: 'Default',
    preview: '#FF6B6B',
    borderRadius: 12,
    borderWidth: 0,
    borderColor: 'transparent',
    shadowOpacity: 0.4,
    shadowRadius: 20,
  },
  {
    id: 'elegant',
    name: 'Elegant',
    preview: '#D4AF37',
    borderRadius: 20,
    borderWidth: 2,
    borderColor: '#D4AF37',
    shadowOpacity: 0.3,
    shadowRadius: 25,
  },
  {
    id: 'minimal',
    name: 'Minimal',
    preview: '#000000',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#FFFFFF',
    shadowOpacity: 0.2,
    shadowRadius: 10,
  },
  {
    id: 'rounded',
    name: 'Rounded',
    preview: '#4ECDC4',
    borderRadius: 30,
    borderWidth: 0,
    borderColor: 'transparent',
    shadowOpacity: 0.5,
    shadowRadius: 30,
  },
  {
    id: 'vintage',
    name: 'Vintage',
    preview: '#8B7355',
    borderRadius: 8,
    borderWidth: 3,
    borderColor: '#8B7355',
    shadowOpacity: 0.35,
    shadowRadius: 15,
  },
  {
    id: 'modern',
    name: 'Modern',
    preview: '#7C4DFF',
    borderRadius: 16,
    borderWidth: 0,
    borderColor: 'transparent',
    shadowOpacity: 0.45,
    shadowRadius: 22,
  },
  {
    id: 'classic',
    name: 'Classic',
    preview: '#2C3E50',
    borderRadius: 12,
    borderWidth: 2,
    borderColor: '#34495E',
    shadowOpacity: 0.3,
    shadowRadius: 18,
  },
  {
    id: 'playful',
    name: 'Playful',
    preview: '#FF69B4',
    borderRadius: 25,
    borderWidth: 4,
    borderColor: '#FF1493',
    shadowOpacity: 0.5,
    shadowRadius: 25,
  },
];

export const getCardStyleById = (id) => {
  return CARD_STYLES.find(style => style.id === id) || CARD_STYLES[0];
};

export default CARD_STYLES;
